import * as angular from "angular";
import {IController, IScope} from "angular";
import * as _ from "lodash"
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import {ShippersDialogService} from "../../services/shippers-dialog-service.service";

export class ShipperPreferencesCtrl implements IController {

  id: string;
  public disable: boolean;
  public shipper: any;

  constructor(private $scope: IScope, private bringozLoaderService: BringozLoaderService, private $shipper,
              private commonsAlertsService: CommonsAlertsService, private shippersDialogService: ShippersDialogService, private $log) {
  }

  $onInit() {
    this.disable = false;
    if (!_.isUndefined(this.id)) {
      this.$shipper(this.id).$bindCtrlToId(this.$scope, this, 'shipper', 'id');
    }
  }

  updateLanguageAndRegion(propertyName) {
    this.bringozLoaderService.on();
    this.disable = true;
    this.$shipper(this.id).$update(this.shipper)
      .then(() => {
        this.commonsAlertsService.preferencesByNameSuccess(propertyName);
        this.disable = false;
      })
      .catch((error) => {
        this.commonsAlertsService.preferencesError();
        this.disable = false;
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  onActivateOrDeactivateShipper($event) {
    if (this.disable) return;

    const shipperCopy = angular.copy(this.shipper);
    shipperCopy.active = !shipperCopy.active;
    this.disable = true;
    this.shippersDialogService.onActivateOrDeactivateShipper(shipperCopy, $event)
      .then(() => {
        this.bringozLoaderService.on();
        this.$shipper(this.shipper.id).$update(shipperCopy)
          .then(() => {
            this.commonsAlertsService.preferencesByNameSuccess('User Status');
          })
          .catch((error) => {
            this.commonsAlertsService.preferencesError();
          })
          .finally(() => {
            this.bringozLoaderService.off();
            this.disable = false;
          })
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }


}

angular
  .module('bringoz.admin.shippers')
  .component('shipperPreferences', {
    bindings: {
      id: '<'
    },
    template: require('./shipper-preferences.html').default,
    controller: ShipperPreferencesCtrl
  });
